module.exports = require('./components/card');
